import {UserAccount} from '../../__generated__/resolvers-types';
import {FeatureObject} from '../../types/FeatureObject';

/**
 * Filter features by user permissions
 * @param user
 * @returns
 */
export function filterByPermission(user?: UserAccount | null): (f: FeatureObject) => boolean {
  return (f) => (!user ? !f.permission : !f.permission || user?.permissions?.includes(f.permission));
}
